import {useCallback, useContext} from 'react';
import PerformanceMonitorEffectContext from 'src/internal/provider/PerformanceMonitorEffectContext';

import type {EffectCallback} from 'react';

export default function usePerformanceMonitorEffect(): (
  callback: EffectCallback,
) => ReturnType<EffectCallback> {
  const effect = useContext(PerformanceMonitorEffectContext);

  return useCallback(
    (callback: EffectCallback) => {
      try {
        return callback();
      } finally {
        effect();
      }
    },
    [effect],
  );
}
